<template>
    <div :style="blockColor" class="hiq-event-view__text-and-image">
        <div class="hiq-event-view__text-and-image--image__wrapper">
            <img class="hiq-event-view__text-and-image--image" :src="event.image.largeSrc ||  event.image.src">
        </div>
        
        <div class="hiq-event-view__text-and-image--text" :class="isVisitSite ? 'visit' : ''" :style="textColor" v-html="formatIngress(event.ingress)"></div>
    </div>
</template>

<script>
export default {
    name: 'TextAndImage',
    data() {
        return {

        }
    },
    computed: {
        event(){ return this.$store.state.event; },
        isVisitSite() { return this.$store.state.isVisitSite; },
        blockColor(){ 
            return this.$store.getters.blockColor; 
        },
        textColor(){ 
            if(this.$store.state.isVisitSite){
                return { color: '#FFFFFF' }
            } else {
                return { color: '#000' }
            }
        }
    },
    methods: {
        formatIngress(ingress){
            if(this.$store.state.isVisitSite){
                ingress = ingress.replace(/<p/g, '<p style="color:#fff" ').replace(/<a/g, '<a style="color:#fff"').replace(/<ul/g, '<ul style="color:#fff"').replace(/<ol/g, '<ol style="color:#fff"')
            } else {
                ingress = ingress.replace(/<p/g, '<p style="color:#000" ').replace(/<a/g, '<a style="color:#000"').replace(/<ul/g, '<ul style="color:#000"').replace(/<ol/g, '<ol style="color:#000"')
            }
            return ingress;
        }
    }
}
</script>